import type {
  EmployeePointsCalculation,
  EmployeeScore,
} from "./types";
import type { EmployeePointsDateRange } from "@/api/employeePoints";

function parseLocalDate(dateStr: string): Date {
  return new Date(`${dateStr}T00:00:00`);
}

function formatDateKey(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function datesInRange({ from, to }: EmployeePointsDateRange): string[] {
  const start = parseLocalDate(from);
  const end = parseLocalDate(to);
  const days: string[] = [];

  for (const date = start; date <= end; date.setDate(date.getDate() + 1)) {
    days.push(formatDateKey(date));
  }

  return days;
}

function zeroPointCalculation(
  employeeId: string,
  calculatedOn: string
): EmployeePointsCalculation {
  return {
    id: `missing-${employeeId}-${calculatedOn}`,
    calculatedOn,
    totalPoints: 0,
    replyPoints: null,
    closePoints: null,
    reviewPoints: null,
    pointsByAction: null,
  };
}

export function fillMissingDailyPoints(
  scores: EmployeeScore[],
  dateRange: EmployeePointsDateRange
): EmployeeScore[] {
  const days = datesInRange(dateRange);

  return scores.map((score) => {
    const calculationsByDay = new Map(
      score.recentPointsCalculations.map((calculation) => [
        calculation.calculatedOn,
        calculation,
      ])
    );

    const recentPointsCalculations = days.map(
      (day) => calculationsByDay.get(day) ?? zeroPointCalculation(score.id, day)
    );

    return {
      ...score,
      latestPoints:
        recentPointsCalculations[recentPointsCalculations.length - 1]
          ?.totalPoints ?? null,
      recentPointsCalculations,
    };
  });
}
